import React from 'react';
import { memberBenefits } from '../../data/foundingProgram';
export function MemberBenefits() {
  return <section id="benefits" className="scroll-mt-20 border-b border-[#D4AF37]/12 bg-[#08070A]" data-id="element-1446" data-mp="37kn4ped3yt8j">
      <div className="mx-auto w-full max-w-7xl px-5 py-20 sm:px-8" data-id="element-1447" data-mp="2swscs06xcswi">
        <div className="max-w-2xl" data-id="element-1448" data-mp="2xu0ww6bmv70e">
          <p className="text-[10px] font-medium uppercase tracking-[0.32em] text-[#D4AF37]" data-id="element-1449" data-mp="2xvbxxydp20nt">
            Founding membership
          </p>
          <h2 className="mt-5 font-serif text-3xl leading-tight text-[#FDFBF7] sm:text-5xl" data-id="element-1450" data-mp="3liboeivfvuc0">
            What Founding Members receive.
          </h2>
        </div>

        <div className="mt-12 grid gap-px border border-[#D4AF37]/15 sm:grid-cols-2 lg:grid-cols-4" data-id="element-1451" data-mp="3cix1ftehe1w9">
          {memberBenefits.map(benefit => {
          const Icon = benefit.icon;
          return <article key={benefit.title} className="flex min-h-44 flex-col justify-between border-[#D4AF37]/15 p-6 sm:border-b sm:border-r lg:[&:nth-child(4n)]:border-r-0 lg:[&:nth-last-child(-n+4)]:border-b-0" data-id="element-1452" data-mp="21302dccxi1lb">
                <Icon className="h-5 w-5 text-[#D4AF37]" aria-hidden="true" data-id="element-1453" data-mp="16aa5nkjdm5qo" />
                <h3 className="mt-8 font-serif text-xl leading-snug text-[#FDFBF7]" data-id="element-1454" data-mp="1k90351a3y7fk">
                  {benefit.title}
                </h3>
              </article>;
        })}
        </div>
      </div>
    </section>;
}